import React from "react";
import { useTranslation } from "react-i18next";
import { X } from "./NavigationIcons";
import "./navigation.css";

const KeyboardShortcutsModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const shortcuts = [
    {
      section: t("navigation"),
      items: [
        { label: t("dashboard.title"), keys: ["⌘/Ctrl", "1"] },
        { label: t("tree_cadastre"), keys: ["⌘/Ctrl", "2"] },
        { label: t("map_view"), keys: ["⌘/Ctrl", "3"] },
        { label: t("sensors_monitoring"), keys: ["⌘/Ctrl", "4"] },
        { label: t("projects"), keys: ["⌘/Ctrl", "5"] },
        { label: t("tasks_workflows"), keys: ["⌘/Ctrl", "6"] },
        { label: t("data_analysis"), keys: ["⌘/Ctrl", "7"] },
        { label: t("settings"), keys: ["⌘/Ctrl", "8"] },
        { label: t("toggle_project_sidebar"), keys: ["⌘/Ctrl", "K"] },
        { label: t("toggle_mobile_menu"), keys: ["⌘/Ctrl", "B"] },
      ],
    },
    {
      section: t("general"),
      items: [
        { label: t("focus_search"), keys: ["⌘/Ctrl", "S"] },
        { label: t("show_shortcuts"), keys: ["?"] },
        { label: t("close_overlays"), keys: ["Esc"] },
      ],
    },
  ];

  return (
    <div className="shortcuts-modal-overlay" onClick={onClose}>
      <div className="shortcuts-modal" onClick={(e) => e.stopPropagation()}>
        <div className="shortcuts-header">
          <h2 className="shortcuts-title">{t("keyboard_shortcuts")}</h2>
          <button className="shortcuts-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="shortcuts-content">
          {shortcuts.map((section, index) => (
            <div key={index} className="shortcuts-section">
              <h3 className="shortcuts-section-title">{section.section}</h3>
              {section.items.map((item, itemIndex) => (
                <div key={itemIndex} className="shortcut-item">
                  <span className="shortcut-label">{item.label}</span>
                  <div className="shortcut-keys">
                    {item.keys.map((key, keyIndex) => (
                      <kbd key={keyIndex} className="shortcut-key">
                        {key}
                      </kbd>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyboardShortcutsModal;
